<template>
    <div v-loading="loading" class="container">
        <label for="email">メールアドレス</label>
        <el-input
            id="email"
            v-model="postData.username"
            class="input"
            placeholder="sample@crypto-city.net"
            autosize
            @keyup.enter.native="signin"
        />
        <label for="password">パスワード</label>
        <el-input
            id="password"
            v-model="postData.password"
            class="input"
            placeholder="半角6文字以上"
            type="password"
            autosize
            @keyup.enter.native="signin"
        />
        <router-link to="/reminder" class="forget">パスワードを忘れた方はこちら</router-link>
        <SubmitBtn class="login-btn" @click="signin">ログイン</SubmitBtn>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SubmitBtn from './SubmitBtn.vue';

export default {
    components: { SubmitBtn },
    data() {
        return {
            loading: false,
            postData: {
                username: '',
                password: '',
            },
        };
    },
    computed: {
        ...mapGetters(['getHomeURL', 'getIsCpta']),
    },
    methods: {
        ...mapActions(['authenticate']),
        async signin() {
            if (this.loading) return;

            this.loading = true;

            try {
                const {
                    data: { access_token, is_force_login },
                } = await this.$axios.post('/oauth/token', this.postData);
                await this.authenticate({
                    app: this,
                    token: access_token,
                    is_force_login,
                });

                if (this.getIsCpta) {
                    this.$router.replace('cpta/customers');
                } else {
                    const userAgent = window.navigator.userAgent.toLowerCase();
                    if (userAgent.indexOf('chrome') === -1) {
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message:
                                '※このサービスはGoogle Chromeでのご利用を推奨しております。<br>それ以外のブラウザをご利用の場合は、Google Chromeに切り替えてご利用ください。',
                        });
                    }
                    this.$router.replace(this.getHomeURL);
                }
            } catch (error) {
                this.$message.error({
                    type: 'error',
                    message: error.response?.data?.title || 'ログインに失敗しました。',
                });

                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/personal/main.scss';

.container {
    display: grid;
    box-sizing: border-box;
    grid-template-columns: auto 1fr;
    align-items: center;
    row-gap: 2.5rem;
    column-gap: 2rem;
    width: 100%;
    max-width: 46rem;
    padding: 0 2rem;

    @include sp {
        grid-template-columns: 1fr;
        row-gap: 0.9rem;
    }
}
label {
    text-align: right;
    @include sp {
        text-align: left;
        font-weight: bold;
    }
}
.input {
    @include sp {
        margin-bottom: 1rem;
    }
}
.forget {
    text-align: right;
    grid-column: span 2;
    padding: 0.3rem 0;

    @include sp {
        grid-column: span 1;
    }
}
.login-btn {
    grid-column: span 2;
    justify-self: center;
    @include sp {
        grid-column: span 1;
        margin-top: 1rem;
    }
}
</style>
